import React, { Component } from "react";
import Collapser from "../common/Collapser";
import CheckBox from "../common/form/CheckBox";
import Form from "../common/form/Form";
import Modal from "../common/Modal";
import ok from "../../../img/notification_ready.svg";
import error from "../../../img/icons/status_decline.svg";
import PropTypes from "prop-types";
import CheckBoxNotification from "../common/form/CheckboxNotification";

export default class NotificationSettings extends Component {

  constructor(props) {
    super(props);

    var companies = [];
    var settings = [];

    if (props.notificationSettings) {
      // Фильтруем notificationSettings, исключая "Счет-фактуры" из Subscriptions
      const filteredNotificationSettings = props.notificationSettings.map((company) => {

        // Исключаем подписки с name === 'Счет-фактуры'
        const filteredSubscriptions = company.Subscriptions.filter(
          (subscription) => subscription.name !== 'Счета-фактуры'
        );

        // Если у компании остались подписки после фильтрации, добавляем её в список компаний
        if (filteredSubscriptions.length > 0) {
          companies.push(company.CompanyId);
        }

        return {
          ...company,
          Subscriptions: filteredSubscriptions, // Сохраняем только отфильтрованные подписки
        };
      }).filter((company) => company.Subscriptions.length > 0); // Исключаем компании без подписок


      // Обрабатываем только отфильтрованные данные
      filteredNotificationSettings.forEach((company) => {
        company.Subscriptions.forEach((subscription) => {
          subscription.notificationWay.forEach((way) => {
            if (way.isChecked) {
              settings.push({
                disabled: subscription.name === "Акции и полезные материалы",
                CompanyId: company.CompanyId,
                NotificationTypeId: subscription.id,
                NotificationWayId: way.id,
              });
            }
          });
        });
      });
      this.state = {
        companies,
        settings,
        initialSettings: [...settings],
        notificationSettings: filteredNotificationSettings, // Сохраняем отфильтрованные настройки
      };
    } else {
      this.state = {
        companies: [],
        settings: [],
        initialSettings: [],
        notificationSettings: [],
      };
    }
  }
  static contextTypes = {
    currentLanguage: PropTypes.object,
    translate: PropTypes.func,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.notificationSettings != this.props.notificationSettings) {
      var companies = [];
      var settings = [];

      nextProps.notificationSettings.map((company) => {
        companies[companies.length] = company.CompanyId;
        company.Subscriptions.map((subscription) => {
          subscription.notificationWay.map((way) => {
            if (way.isChecked) {
              settings[settings.length] = {
                CompanyId: company.CompanyId,
                NotificationTypeId: subscription.id,
                NotificationWayId: way.id,
              };
            }
          });
        });
      });

      this.setState({
        companies,
        settings,
      });
    }

    if (
      nextProps.savingStatus != this.props.savingStatus &&
      (nextProps.savingStatus == "success" ||
        nextProps.savingStatus == "error") &&
      this.state.sendRequest
    ) {
      if (nextProps.savingStatus == "success") {
        this.setState({ initialSettings: [...this.state.settings], modal: true, sendRequest: false });
      } else {
        this.setState({ modal: true, sendRequest: false });
      }
      if (nextProps.savingStatus == "success") {
        setTimeout(() => {
          this.setState({ modal: false });
        }, 2000);
      }
    }
  }

  changeSelection = (company, type, way) => {
    var settings = [...this.state.settings];
    var index = this.getIndex(company, type, way);

    if (index == -1) {
      settings[settings.length] = {
        CompanyId: company,
        NotificationTypeId: type,
        NotificationWayId: way,
        disabled: false,
      };
    } else {
      settings.splice(index, 1);
    }

    this.setState({ settings });
  };

  changeAllAccessibleCheckboxes = (isParentChecked, item, isIndeterminate) => {
    const { settings } = this.state;

    const disabledSettings = settings.filter((el) => el.disabled);
    let updatedSettings = settings.filter((el) => el.disabled === false);
    const company = this.state.notificationSettings.find(
      (company) => company.CompanyId === item.CompanyId
    );

    if (isIndeterminate && updatedSettings.some(setting => setting.CompanyId === item.CompanyId)) {
      updatedSettings = updatedSettings.filter(
        (setting) => setting.CompanyId !== item.CompanyId
      );
    } else if (company) {
      company.Subscriptions.forEach((subscription) => {
        if (subscription.name !== "Акции и полезные материалы") {
          const way = subscription.notificationWay[1];

          const settingIndex = updatedSettings.findIndex(
            (setting) =>
              setting.CompanyId === item.CompanyId &&
              setting.NotificationTypeId === subscription.id &&
              setting.NotificationWayId === way.id &&
              setting.disabled === false
          );

          if (!way.isEnabled) {
            return;
          }

          if (isParentChecked && settingIndex === -1) {
            updatedSettings.push({
              CompanyId: item.CompanyId,
              NotificationTypeId: subscription.id,
              NotificationWayId: way.id,
              disabled: false,
            });
          } else if (!isParentChecked && settingIndex === -1) {
            if (isIndeterminate) {
              updatedSettings.push({
                CompanyId: item.CompanyId,
                NotificationTypeId: subscription.id,
                NotificationWayId: way.id,
                disabled: false,
              });
            } else {
              updatedSettings.push({
                CompanyId: item.CompanyId,
                NotificationTypeId: subscription.id,
                NotificationWayId: way.id,
                disabled: false,
              });
            }
          } else if (/* isParentChecked &&  */settingIndex !== -1) {
            updatedSettings.splice(settingIndex, 1);
          }/*  else if (!isParentChecked && settingIndex !== -1) {
            updatedSettings.splice(settingIndex, 1);
          } */
          if (!isParentChecked && !isIndeterminate) {
            if (settingIndex === -1) {
              if (subscription.id <= 2) {
                updatedSettings.push({
                  CompanyId: item.CompanyId,
                  NotificationTypeId: subscription.id,
                  NotificationWayId: way.id,
                  disabled: false,
                });
              }

            }
          }
        }
      });
    }
    const res = [...disabledSettings, ...updatedSettings];
    // Функция для получения уникального ключа для каждого объекта
    const getUniqueKey = (item) =>
      `${item.CompanyId}-${item.NotificationTypeId}-${item.NotificationWayId}`;

    // Оставляем только уникальные элементы
    const uniqueRes = res.filter((item, index, self) => {
      const uniqueKey = getUniqueKey(item);
      // Проверяем, что это первый элемент с таким ключом
      return index === self.findIndex(t => getUniqueKey(t) === uniqueKey);
    });

    this.setState({ settings: uniqueRes });
    /*     this.setState({ settings: res }); */
  };
  isChecked = (company, type, way) => {
    var settings = [...this.state.settings];
    var index = this.getIndex(company, type, way);

    return index != -1;
  };
  isValid = () => {
    const { settings, initialSettings } = this.state;
    // Если длина массивов разная, они точно не равны
    if (initialSettings.length !== settings.length) {
      return true;
    }

    // Преобразуем каждый массив в множество строковых представлений объектов,
    // отсортированных по ключам, чтобы исключить влияние порядка элементов
    const sortedSettings = settings
      .map(obj => JSON.stringify(obj, Object.keys(obj).sort()))
      .sort();

    const sortedInitialSettings = initialSettings
      .map(obj => JSON.stringify(obj, Object.keys(obj).sort()))
      .sort();

    // Сравниваем преобразованные массивы
    for (let i = 0; i < sortedSettings.length; i++) {
      if (sortedSettings[i] !== sortedInitialSettings[i]) {
        return true; // Массивы отличаются
      }
    }

    return false; // Массивы одинаковы
  };
  getIndex = (company, type, way) => {
    var settings = [...this.state.settings];
    for (var i = 0; i < settings.length; i++) {
      if (
        settings[i].CompanyId == company &&
        settings[i].NotificationTypeId == type &&
        settings[i].NotificationWayId == way
      ) {
        return i;
      }
    }
    return -1;
  };

  onSubmit = () => {
    var { companies, settings } = this.state;
    var body = [];
    companies.map((item, key) => {
      body.push("AccessibleCompanies[" + key + "]=" + item);
    });
    settings.map((item, key) => {
      body.push("Subscriptions[" + key + "][CompanyId]=" + item.CompanyId);
      body.push(
        "Subscriptions[" +
        key +
        "][NotificationTypeId]=" +
        item.NotificationTypeId
      );
      body.push(
        "Subscriptions[" +
        key +
        "][NotificationWayId]=" +
        item.NotificationWayId
      );
    });

    this.setState({ sendRequest: true });
    this.props.saveSettings(body.join("&"));
  };

  render() {
    let { notificationSettings, savingStatus, message } = this.props;

    return (
      <Form onSubmit={this.onSubmit}>
        <div className="profile-form__container">
          <div className="profile-form__item-header">
            <p className="profile-form__item-header-text" >
              Компании
            </p>
            <p className="profile-form__item-header-text">
              E-mail
            </p>
          </div>
          {this.state.notificationSettings.map((item, key) => (
            <NotificationSetting
              {...item}
              item={item}
              changeSelection={this.changeSelection}
              changeAllAccessibleCheckboxes={this.changeAllAccessibleCheckboxes}
              isChecked={this.isChecked}
              key={key}
              listIndex={key}
              translate={this.context.translate}
              settings={this.state.settings}
            />
          ))}
          <div className="profile-form__item_btn">
            <button
              type="submit"
              className={
                "u-btn u-btn_adapt-type_wide" + (this.isValid() ? "" : " u-btn_disabled") +
                (savingStatus == "load" ? " disabled" : "")
              }
            >
              {this.context.translate("Сохранить")}
            </button>
          </div>
        </div>
        {this.state.modal ? (
          <Modal
            modalSize="s"
            onClickBackground={() => {
              this.setState({ modal: false });
            }}
            classNameContent="modal modal_visible modal-wrapper modal__xs text-center"
          >
            <p>
              <img width={60} src={savingStatus == "success" ? ok : error} />
            </p>
            <h2 className="form__title">
              {savingStatus == "success"
                ? this.context.translate("Настройки успешно сохранены")
                : this.context.translate("Ошибка сохранения")}
            </h2>
            {message ? <p>{message}</p> : null}
          </Modal>
        ) : null}
      </Form>
    );
  }
}

function NotificationSetting({
  CompanyId,
  CompanyName,
  Subscriptions,
  changeSelection,
  isChecked,
  translate,
  settings,
  changeAllAccessibleCheckboxes,
  item,
  listIndex
}) {
  const [isParentChecked, setIsParentChecked] = React.useState(false);
  const [isIndeterminate, setIsIndeterminate] = React.useState(false);

  // Проверяем состояние всех дочерних чекбоксов
  React.useEffect(() => {
    const allChecked = Subscriptions.every((item) => {
      return isChecked(CompanyId, item.id, item.notificationWay[1].id)
    }
    );
    const someChecked = Subscriptions.some((item) =>
      isChecked(CompanyId, item.id, item.notificationWay[1].id)
    );
    setIsParentChecked(allChecked);
    setIsIndeterminate(someChecked && !allChecked);
  }, [Subscriptions, isChecked, CompanyId, settings]);

  // Обработчик изменения родительского чекбокса
  const handleParentChange = () => {
    changeAllAccessibleCheckboxes(isParentChecked, item, isIndeterminate);
  };

  return (
    <div>
      <div className="profile-form__item-company-name" >
        <Collapser
          label={CompanyName}
          labelClassName="u-more-link_notification"
          labelActiveClassName="u-more-link_notification-open"
          typeCollapsed={listIndex === 0 ? "notification" : ""}
          className={"u-more-link_notification-width"}
        >
          <div className="notice-form__wrap-new">
            {Subscriptions.map((item, key) => (
              <NotificationSettingItem
                {...item}
                CompanyId={CompanyId}
                isChecked={isChecked}
                changeSelection={changeSelection}
                disabled={item.name === 'Акции и полезные материалы'}
                key={key}
              />
            ))}
          </div>
        </Collapser>
        <div style={{ marginLeft: "-28px" }}>
          <CheckBoxNotification
            id={`parent-${CompanyId}`}
            className="form__checkbox-notification"
            label={""}
            value={isParentChecked}
            indeterminate={isIndeterminate}
            onChange={handleParentChange}
            disabled={false}
          />
        </div>
      </div>
    </div>
  );
}

class NotificationSettingItem extends Component {
  render() {
    var {
      CompanyId,
      id,
      name,
      notificationWay,
      changeSelection,
      isChecked,
      disabled,
    } = this.props;


    const notificationText = "Уведомления о событиях по вашим договорам и заявкам"

    return (
      <div
        className="notice-form__item"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <p
          className={`notice-form__item-name ${disabled ? "notice-form__item-name-disabled" : ""
            }`}
        >
          {name}
        </p>
        <CheckBoxNotification
          id={CompanyId + "-" + id + "-" + notificationWay[1].id}
          className="form__checkbox-notification"
          label={""}
          value={isChecked(CompanyId, id, notificationWay[1].id)}
          onChange={() => {
            changeSelection(CompanyId, id, notificationWay[1].id);
          }}
          disabled={disabled}
          tooltip={disabled ? "Уведомления временно не отправляются" : id === 4 ? notificationText : ""}
        />
      </div>
    );
  }
}
